import { StoreAction } from '../../types';
import {
  SET_COMPLIANCE_ERROR,
  SET_COVIE_DATA,
  UPDATE_APPLICATION,
  UPDATE_APPLICATION_ROUTE,
} from '../contants';

export default function application(
  state: any = {
    data: {},
    currentRoute: null,
    error: null,
  },
  action: StoreAction,
) {
  switch (action.type) {
    case UPDATE_APPLICATION: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case UPDATE_APPLICATION_ROUTE:
      return {
        ...state,
        currentRoute: action.payload,
      };
    case SET_COVIE_DATA:
      return {
        ...state,
        covieData: action.payload,
      };
    case SET_COMPLIANCE_ERROR:
      return {
        ...state,
        compliance: {
          errors: action.payload,
        },
      };
    default:
      return state;
  }
}
